export const Logo = ({ white = false, className = 'h-9 w-auto', alt = 'CapableBee — AI Voice Assistant' }) => (
  <img
    src={white ? '/brand/logo-white.png' : '/brand/logo.png'}
    alt={alt}
    className={className}
    width="328"
    height="60"
    data-testid={white ? 'footer-logo' : 'header-logo'}
  />
);
